import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class AuthenticatedPslfDashboardIndexController extends Controller {
  queryParams = ['showEstimator', 'estimator0726'];

  // Debug/testing override: ?showEstimator=true forces the forgiveness estimator
  // tile to render regardless of the usual hero gating (PSLF forms / NSLDS data /
  // annual-reminder state). Read in the dashboard index component via the router.
  @tracked showEstimator: string | null = null;

  // ?estimator0726=true routes the hero estimator CTA to the PSLF-0726 pilot
  // estimator and renders the PSLF recommendation history at the bottom.
  @tracked estimator0726: string | null = null;
}
